import {
  GetJourneyWithCareProfileQuery,
  GetJourneyWithExpertAndConsultsQuery,
  GetJourneyWithExpertQuery,
  GetJourneyWithOnboardingInfoQuery,
  MedicationFragment as Medication,
  ProviderFragment as Provider,
  TimeLogActivityKindEnum
} from '@typing/Generated';

export type MedicationGroups = {
  overTheCounter: Medication[];
  prescription: Medication[];
  vitaminAndSupplement: Medication[];
};

export type ProviderGroups = {
  otherCareProviders: Provider[];
  otherDoctors: Provider[];
  primaryCareProviders: Provider[];
};

export enum BackOrNext {
  BACK = 'back',
  NEXT = 'next'
}

export enum Status {
  ARCHIVED = 'archived',
  CANCELED = 'canceled',
  DRAFT = 'draft',
  COMPLETED = 'completed',
  IN_PROGRESS = 'in_progress',
  NEW = 'new',
  UNPUBLISHED_ITEMS = 'unpublished_items',
  UPDATED = 'updated',
  UPDATING = 'updating',
  VIEWED = 'viewed'
}

export enum MessageTemplateReplacements {
  COMPANY_NAME = '{companyName}',
  EXPERT_FIRST_NAME = '{expertFirstName}',
  OWNER_MEMBER_FIRST_NAME = '{ownerMemberFirstName}'
}

export const nonBillableTimeLogActivityKinds = [
  TimeLogActivityKindEnum.CARE_PLAN_LITE,
  TimeLogActivityKindEnum.CLIENT_MESSAGING,
  TimeLogActivityKindEnum.CONSULT_PREP,
  TimeLogActivityKindEnum.MANDATED_REPORTING,
  TimeLogActivityKindEnum.NON_BILLABLE_ADDITIONAL_CONSULTS_DOCUMENTATION,
  TimeLogActivityKindEnum.NON_BILLABLE_CARE_PLAN_CREATION,
  TimeLogActivityKindEnum.NON_BILLABLE_CONCIERGE_SERVICES,
  TimeLogActivityKindEnum.NON_BILLABLE_INITIAL_CONSULT_DOCUMENTATION,
  TimeLogActivityKindEnum.NON_BILLABLE_MISCELLANEOUS,
  TimeLogActivityKindEnum.NON_BILLABLE_NO_SHOW,
  TimeLogActivityKindEnum.NON_BILLABLE_RESOURCE_FINDING_AND_VETTING,
  TimeLogActivityKindEnum.NON_BILLABLE_SECOND_CONSULT_DOCUMENTATION
];

export enum CareProfileSection {
  BASIC_INFO = 'basic_info',
  FINANCIAL = 'financial',
  FUNCTIONAL = 'functional',
  LEGAL = 'legal',
  MAIN = 'main',
  MEDICAL = 'medical',
  NEXT_CONSULT = 'next_consult',
  SOCIAL = 'social',
  STAGE = 'stage',
  WELLBEING = 'wellbeing'
}

export enum InitialConsultReportSection {
  BASIC_INFO = 'basic_info',
  CLIENT_INFO = 'client_info',
  CONCLUSION = 'conclusion',
  STAGE = 'stage',
  MAIN = 'main'
}

export enum ContentConditionSource {
  ALWAYS = 'always',
  CARE_PROFILE = 'care_profile',
  CONSULTS = 'consults',
  JOURNEY = 'journey',
  LEGAL_DOCUMENTS = 'legal_documents',
  MEDICATION_TRACKER = 'medication_tracker',
  PROVIDER_LIST = 'provider_list'
}

export enum ConsultReportValues {
  INITIAL_ASSESSMENT = 'initial_assessment',
  CONSULT_REPORT = 'consult_report'
}

export enum PersonalizeExperienceFields {
  PROVIDER_EMOTIONAL_STATE = 'provider_emotional_state',
  PROVIDER_FEELS_SUPPORTED = 'provider_feels_supported'
}

export enum InitialConsultFields {
  AGE = 'age',
  CAREGIVER_TYPES = 'caregiver_types',
  CLIENT_CULTURAL_CONSIDERATIONS = 'client_cultural_considerations',
  CLIENT_IS_VETERAN = 'client_is_veteran',
  CLIENT_LOCATION = 'client_location',
  CLIENT_ROLE_RELATIONSHIP = 'client_role_relationship',
  CLIENT_TIMEZONE = 'client_timezone',
  COGNITIVE_STATUSES = 'cognitive_statuses',
  CONCERNS = 'concerns',
  CULTURAL_CONSIDERATIONS = 'cultural_considerations',
  EMERGENCY_PLAN_ITEMS = 'emergency_plan_items',
  EMOTIONAL_CONCERNS = 'emotional_concerns',
  FALL_COUNT = 'fall_count',
  FINANCIAL_MANAGER = 'financial_manager',
  HEALTH_INSURANCE_TYPES = 'health_insurance_types',
  INSURANCE_TYPES = 'insurance_types',
  IS_VETERAN_GUARDIAN = 'is_veteran_guardian',
  IS_VETERAN_PARTNER = 'is_veteran_partner',
  IS_VETERAN_SELF = 'is_veteran_self',
  LANGUAGE_CODE = 'language_code',
  LEGAL_DPOA_FINANCES_STATUS = 'legal_dpoa_finances_status',
  LEGAL_DPOA_HEALTH_CARE_STATUS = 'legal_dpoa_health_care_status',
  LEGAL_LIVING_WILL_STATUS = 'legal_living_will_status',
  LEGAL_TRUST_STATUS = 'legal_trust_status',
  LEGAL_WILL_STATUS = 'legal_will_status',
  LOCATION = 'location',
  MARITAL_STATUS = 'merital_status',
  MEDICATIONS_AFFORDABLE = 'medications_affordable',
  NAME = 'name',
  PROVIDER_EMOTIONAL_STATE = 'provider_emotional_state',
  RECENT_HOSPITALIZATION = 'recent_hospitalization',
  RELIGION = 'religion',
  RESIDENCE_TYPE = 'residence_type',
  STABILITY_SUPPORTS = 'stability_supports',
  STAGES = 'stages',
  STAIRS_REQUIRED_FOR_EXIT = 'stairs_required_for_exit',
  TYPES_OF_SUPPORT_NEEDED = 'types_of_support_needed'
}

export type JourneyFromSomeQuery =
  | GetJourneyWithCareProfileQuery['journey']
  | GetJourneyWithExpertAndConsultsQuery['journey']
  | GetJourneyWithExpertQuery['journey']
  | GetJourneyWithOnboardingInfoQuery['journey'];
